<template>
	<div class="huntsman_wrap clearfix">
		<el-steps :active="1" finish-status="success" simple style="height: 80px;">
			<el-step title="1 个人基本信息"></el-step>
			<el-step title="2 个人其他信息"></el-step>
			<el-step title="3 成功提交信息"></el-step>
		</el-steps>

		<div class="infor_box clearfix">
			<div class="title">个人基本信息</div>
			<el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-position="left" label-width="135px">
				<el-form-item label="所在城市" prop="city">
					<!-- <el-input placeholder="请填写您当前所在城市" v-model="ruleForm.city"></el-input> -->
					<!-- <el-cascader :props="props" v-model="ruleForm.city" @change="handleChange"></el-cascader> -->

					<el-cascader style="width: 100%;" ref="cascaderAddr" v-model="ruleForm.city" placeholder="请选择城市" :options="cascaderData" @active-item-change="handleItemChange"
					 @change="handleChange1" :props="{
					      value: 'id',
					      label: 'name',
					      children: 'cities'
					    }"></el-cascader>

				</el-form-item>
				<el-form-item label="姓名" prop="name">
					<el-input placeholder="请填写与身份证姓名完全一致" v-model="ruleForm.name"></el-input>
				</el-form-item>
				<el-form-item label="身份证" prop="card">
					<el-input placeholder="与身份证姓名完全一致" v-model="ruleForm.card"></el-input>
				</el-form-item>
				<el-form-item label="授权签约手机号码" prop="phone">
					<el-input placeholder="请填写常用手机号" v-model="ruleForm.phone"></el-input>
				</el-form-item>
				<el-form-item label="微信号" prop="wechat">
					<el-input placeholder="请填写常用微信号" v-model="ruleForm.wechat"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button @click="saveDada">保存</el-button>
					<el-button type="primary" style="width: auto;" @click="next_btn('ruleForm')">下一步</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
	import { BasicInfor, CityList } from '../../common/api/http.js'
	export default {
		data() {
			return {
				cascaderData: [],
				ruleForm: {
					city: '',
					name: '',
					card: '',
					phone: '',
					wechat: ''
				},
				province_id:'',//城市省份ID
				city_id:'',//城市选择ID
				rules: {
					city: [{
						type: 'array',
						required: true,
						message: '请选择城市',
						trigger: ['blur','change']
					}],
					name: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}],
					card: [{
						required: true,
						message: '请输入身份证号',
						trigger: 'blur'
					}],
					phone: [{
						required: true,
						message: '请输入手机号',
						trigger: 'blur'
					}],
					wechat: [{
						required: true,
						message: '请输入微信号',
						trigger: 'blur'
					}],
				},
				sgs_basic_infor: [], //缓存数据
			}
		},
		created() {
			// 缓存的数据回显
			let infor = localStorage.getItem('sgs_basic_infor')
			if (infor) {
				JSON.parse(infor).map(item => {
					// this.ruleForm.city = item.city
					this.ruleForm.name = item.name
					this.ruleForm.card = item.card
					this.ruleForm.phone = item.phone
					this.ruleForm.wechat = item.wechat
				})
			}

			this.getNodes()
		},
		methods: {
			// 城市数据
			getNodes(val) {
				let sizeArea
				if (!val) {
					sizeArea = 0
				} else {
					sizeArea = 1
				}
				// 获取省市区数据
				CityList().then(res => {
					let Items = res.data
					if (sizeArea === 0) { // 初始化 加载一级 省
						this.cascaderData = Items.map((value, i) => {
							// console.log(value)
							// console.log(i)
							return {
								id: value.area_id,
								name: value.title,
								cities: []
							}
						})
					} else if (sizeArea === 1) {
						CityList({
							'parent_id': val[0]
						}).then(res => {

							this.cascaderData.map((value, i) => {
								value.cities = res.data.map((value, i) => {
									return {
										id: value.area_id,
										name: value.title
									}
								})
							})
						})
					}
				}).catch(err => {
					console.log(err)
				})

			},
			//当前选择的城市
			handleItemChange(val) {
				console.log(val)
				this.getNodes(val)
			},
			handleChange1(e,name,thsAreaCode) {
				console.log(e)
				this.province_id = e[0]
				this.city_id = e[1]
				// var mystring = this.$refs["cascaderAddr"].getCheckedNodes()[0].pathLabels.toString()
				// // console.log(mystring.replace(/,/g,"/"))
				// this.ruleForm.city = mystring.replace(/,/g,"/")
			},
			next_btn(formName) {
				this.$refs[formName].validate((valid) => {
				  if (valid) {
					// alert('submit!');
					// 认证赏金猎人----基本信息
					let token = window.sessionStorage.getItem('token')
					let data = {
						'api_token':token,
						'province_id':this.province_id,
						'city_id':this.city_id,
						'true_name':this.ruleForm.name,
						'id_card_num':this.ruleForm.card, 
						'sign_mobile':this.ruleForm.phone,
						'wx_name':this.ruleForm.wechat
					}
					console.log(data)
					BasicInfor(data).then(res => {
						console.log(res)
						if(res.code == 0){
							this.$router.push({
								name: 'settings_otherInformation'
							})
						}else{
							this.$message.error(res.msg);
						}
						
					}).catch(err => {
						console.log(err)
					})
					
				  } else {
					return false;
				  }
				});
				// this.$router.push({
				// 	name: 'settings_otherInformation'
				// })
				// this.cache_dade()
			},
			// 保存数据到缓存
			saveDada() {
				this.cache_dade()
			},
			cache_dade() {
				this.sgs_basic_infor = []
				this.sgs_basic_infor.push(this.ruleForm)
				localStorage.removeItem("sgs_basic_infor");
				localStorage.setItem("sgs_basic_infor", JSON.stringify(this.sgs_basic_infor));
			}
			//提交数据
			// submitForm(formName) {
			// 	this.$refs[formName].validate((valid) => {
			// 		if (valid) {
			// 			alert('submit!');
			// 		} else {
			// 			console.log('error submit!!');
			// 			return false;
			// 		}
			// 	});
			// },
		}
	}
</script>

<style lang="less" scoped>
	.huntsman_wrap {
		height: auto;
		background: #fff;

		.title {
			font-size: 24px;
			color: #333;
			line-height: 1;
			font-weight: bold;
			margin-bottom: 35px;
		}

		.infor_box {
			width: 500px;
			margin: 50px 0 0 80px;
		}
	}
</style>
